import { useOrbit3DStore } from "@common/features/Orbit3D/state/orbit3DStore"
import { Billboard, Html, useGLTF } from "@react-three/drei"
import { useCanvasStore } from "@state/canvasStore"
import React from "react"
import { Vector3 } from "three"

function Labels() {
  const touchPoints = useCanvasStore((s) => s.touchPoints)

  const { nodes: model } = useGLTF(
    "/assets/models/vivid_reality_logo_3d_model/scene.glb",
  ) as any
  const setActiveLabel = useOrbit3DStore((s) => s.setActiveLabel)

  const handleClickTouchPoint = (data) => {
    setActiveLabel(data)
  }
  if (touchPoints?.length === 0 || touchPoints === undefined) return null
  return (
    <group scale={0.1}>
      {touchPoints?.map((data, index) => {
        return (
          <TouchPoint
            handleClickTouchPoint={handleClickTouchPoint}
            data={data}
            model={model}
            key={index}
            index={index}
          />
        )
      })}
    </group>
  )
}

type TouchPointProps = {
  data: any
  model: any
  index: number
  handleClickTouchPoint: (data: any) => void
}

export const TouchPoint = (props: TouchPointProps) => {
  const { data, model, handleClickTouchPoint } = props
  const { positions } = data
  const materials = React.useRef<any[]>([])

  return (
    <group
      onClick={() => {
        handleClickTouchPoint(data)
      }}
      position={new Vector3(positions.x, positions.y, positions.z)}
    >
      <Billboard lockX={true} lockY={false} lockZ={false}>
        {data?.title && (
          <group position={[0, 0.25, 0]}>
            <Html color="white" center={true}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "26em",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h1
                  style={{
                    backgroundColor: "#0a2620a5",
                    padding: "0.25em",
                    fontSize: "2.2rem",
                    fontWeight: 600,
                    color: "#fff",
                  }}
                >
                  {data.title}
                </h1>
                <h2
                  style={{
                    // marginTop: "0.5em",
                    backgroundColor: "#0a2620a5",
                    fontFamily: "secondaryFont",
                    padding: "0.25em",
                    fontSize: "1.8rem",
                    fontWeight: 600,
                    color: "var(--accent)",
                  }}
                >
                  {data.value} Available units
                </h2>
              </div>
            </Html>
          </group>
        )}
        <mesh
          scale={0.3}
          onPointerOver={() => (document.body.style.cursor = "pointer")}
          onPointerOut={() => (document.body.style.cursor = "auto")}
          geometry={model["mesh_0"].geometry}
        >
          <meshMatcapMaterial
            ref={(el) => (materials.current[0] = el)}
            opacity={1}
            transparent
            toneMapped={false}
            color={"#7F9089"}
          />
        </mesh>
        <mesh scale={0.3} geometry={model["mesh_1"].geometry}>
          <meshMatcapMaterial
            ref={(el) => (materials.current[1] = el)}
            opacity={1}
            transparent
            toneMapped={false}
            color={"#fff"}
          />
        </mesh>
      </Billboard>
    </group>
  )
}

export default Labels
